/* eslint-disable unused-imports/no-unused-vars */
import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {
  Observable,
  catchError,
  filter,
  map,
  of,
  switchMap,
  take,
  withLatestFrom
} from 'rxjs';
import { AuthFacade } from '~console/app/~store/facades/auth.facade';
import { ROUTES } from '../constants/routes.constants';

export const AUTHENTICATED_GUARD = (
  route: ActivatedRouteSnapshot,
  next: RouterStateSnapshot
): Observable<UrlTree | boolean> => {
  const requestedUrl = next.url;
  const authFacade = inject(AuthFacade);
  const router = inject(Router);
  const accessTokenId = route.queryParams['accessToken'];
  const ntd = route.queryParams['ntd'];

  if (accessTokenId && ntd) {
    authFacade.setLastRequestedRoute(requestedUrl);
    return authFacade.loginWithAccessToken(accessTokenId, ntd).pipe(
      switchMap(() =>
        authFacade.accessToken$.pipe(
          filter(accessToken => !!accessToken),
          take(1),
          map(() => true)
        )
      ),
      catchError(() => of(router.createUrlTree([ROUTES.login])))
    );
  }

  return authFacade.accessToken$.pipe(
    withLatestFrom(authFacade.currentUser$),
    map(([accessToken, currentUser]) => {
      if (currentUser && !currentUser.passwordChanged) {
        authFacade.setLastRequestedRoute(requestedUrl);
        return router.createUrlTree([ROUTES.changePassword]);
      }
      if (!accessToken) {
        authFacade.setLastRequestedRoute(requestedUrl);
        return router.createUrlTree([ROUTES.login]);
      }
      return true;
    })
  );
};
